/**
 * Shopify API Query Limits
 * Single source of truth for all Shopify GraphQL query pagination limits
 */

export const SHOPIFY_LIMITS = {
  // Product variant limits
  VARIANTS_PER_PRODUCT: 250,
  
  // Image limits by context
  IMAGES_LIST_VIEW: 3,           // Product list/grid views
  IMAGES_DETAIL_VIEW: 10,        // Single product detail pages
  IMAGES_COLLECTION_VIEW: 50,    // Collection pages with many products
  
  // Product pagination
  PRODUCTS_INITIAL_BATCH: 24,    // Initial products to load
  PRODUCTS_PER_PAGE: 250,        // Products per pagination request
  
  // Collection pagination
  COLLECTIONS_PER_PAGE: 250,     // Collections per pagination request
  PRODUCTS_PER_COLLECTION: 250,  // Products when fetching a collection
  
  // Progressive loading chunks
  PRODUCTS_PAGINATION_CHUNK: 100, // Chunk size for progressive loading
  
  // Safety limits (max pages to prevent infinite loops)
  MAX_PRODUCT_PAGES: 50,          // Max pages when fetching all products (50 * 250 = 12,500 products)
  MAX_COLLECTION_PAGES: 10,       // Max pages when fetching collections (10 * 250 = 2,500 collections)
  MAX_COLLECTION_PRODUCT_PAGES: 50, // Max pages per collection (50 * 250 = 12,500 products)
} as const;

// Type for the limits object
export type ShopifyLimits = typeof SHOPIFY_LIMITS;

// Helper function to validate limits are within Shopify's GraphQL constraints
export const validateShopifyLimits = () => {
  const maxShopifyLimit = 250;
  const violations: string[] = [];
  
  Object.entries(SHOPIFY_LIMITS).forEach(([key, value]) => {
    if (typeof value === 'number' && value > maxShopifyLimit && !key.startsWith('MAX_')) {
      violations.push(`${key}: ${value} exceeds Shopify max limit of ${maxShopifyLimit}`);
    }
  });
  
  if (violations.length > 0) {
    console.warn('Shopify limit violations detected:', violations);
  }
  
  return violations.length === 0;
};
